import React, { Component } from "react";

import Header from "@components/Header";

class MonetaryAnalysis extends Component {
    render() {
        return (
            <div id="main">
                <Header />
                <section>
                    <header className="content">
                        <h1>MonetaryAnalysis</h1>
                    </header>
                </section>
            </div>
        );
    }
}

export default MonetaryAnalysis;
